// Settings configured here will be merged into the final config object.
export default {
  gradient: {
    'Die 25 besten Winterhotels mit 5 Sternen': [
      'rgba(214, 173, 115, 1)',
      '#a47a00',
      'rgba(214, 173, 115, 0)'
    ],
    'Die 25 besten Winterhotels mit 4 Sternen': [
      'rgba(181,211,241,1)',
      '#779FBF',
      'rgba(216,230,242,0)'
    ],
    'Die 25 besten Winterhotels mit 3 Sternen': [
      'rgba(165, 131, 87, 1)',
      '#824e23',
      'rgba(165, 131, 87, 0)'
    ]
  }
}



// WEBPACK FOOTER //
// ./src/config/base.js